// extracted by mini-css-extract-plugin
export default {"page-layout":"styles_page-layout__gmRs2","wrapper":"styles_wrapper__bpkpR","right-block":"styles_right-block__wek19"};